import React, { useState } from 'react'
import { Alert, Button, Intent, Label, Classes } from '@blueprintjs/core'

import { Row, Col } from 'react-grid-system'
import { useForm } from 'react-hook-form'
import { serverErrorToast, successToast } from '../layout/toaster/toaster'
import css from './users.css'

function UserForm ({ setDialogOpen, patient, createParticipant }) {
  const [loading, setLoading] = useState(false)
  const [firstName, setFirstName] = useState(patient.firstName)
  const [lastName, setLastName] = useState(patient.lastName)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('123123')

  const { register, handleSubmit, errors } = useForm({})

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value)
  }

  const handleLastNameChange = (event) => {
    setLastName(event.target.value)
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  }

  const handlePasswordChange = (event) => {
    setPassword(event.target.value)
  }

  const onSubmit = async (data) => {
    setLoading(true)

    await createParticipant({ ...patient, email: email, firstName: firstName, lastName: lastName, password: password, patientId: patient._id })

    setDialogOpen(false)
    setLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className='bp3-dialog-header'>
        <span className='bp3-icon-large bp3-icon-inbox' />
        <h4>Create Participant Gateway User</h4>
      </div>

      <Row style={{ marginLeft: 10, marginTop: 10 }}>
        <Col>
          <Label style={{ width: '90%', marginTop: 10 }}>
              First Name
              <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  style={{ width: '100%', marginTop: 10 }}
                  onChange={handleFirstNameChange}
                  className={Classes.INPUT} placeholder="User First Name" />
          </Label>
        </Col>
        <Col>
          <Label style={{ width: '90%', marginTop: 10 }}>
            Last Name
            <input
                type="text"
                id="lastName"
                name="lastName"
                onChange={handleLastNameChange}
                style={{ width: '100%', marginTop: 10 }}
                className={Classes.INPUT} placeholder="User Last Name"/>
          </Label>
        </Col>
      </Row>
      <Row style={{ marginLeft: 10 }}>
        <Col>
        <Label style={{ width: '95%', marginTop: 0 }}>
          Email
          <input
              type="text"
              id="email"
              name="email"
              style={{ width: '100%', marginTop: 10 }}
              onChange={handleEmailChange}
              className={Classes.INPUT} placeholder="User Email"/>
        </Label>
        </Col>
      </Row>
      <Row style={{ marginLeft: 10 }}>
        <Col>
          <Label style={{ width: '95%', marginTop: 10 }}>
              Password
              <input
                  type="text"
                  id="password"
                  name="password"
                  style={{ width: '100%', marginTop: 10 }}
                  onChange={handlePasswordChange}
                  className={Classes.INPUT} placeholder="Type the Password"/>
          </Label>
        </Col>
      </Row>

      <Row>
        <Col> </Col>

        <Col>
          <div style={{ marginRight: 0 }}>
            <Button style={{ marginRight: 10 }} onClick={() => setDialogOpen(false)}>Cancel</Button>
            <Button type='submit' intent={Intent.SUCCESS} type='submit' icon='saved' loading={loading} style={{ marginRight: 0 }}>Create</Button>
          </div>
        </Col>
      </Row>

      <Alert>
        <p>Are you sure you want to permanently and all related data?</p>
      </Alert>
    </form>
  )
}

export default UserForm
